import { NotificationCard } from '../../components/Card';
import { Button, Center, Flex, Icon, Text } from '@chakra-ui/react';
import { useMarkAsReadMutation } from '@/store/query/notification';
import { NotificationLink } from '../../components/NotificationLink';
import { NotificationTime } from '../../components/Time';
import {
  RequisitionDetailsSection,
  RequisitionDetailsList,
} from '../requisition-notifications/components';
import { LayersThree02 } from '@kula-ai/icons/dual-tone/LayersThree02';
import { useSurveyNotificationData } from './utils/useSurveyNotificationData';
import { useHistory } from 'react-router-dom';

const SurveyRequest = ({ notification = {}, onClose = () => {} }) => {
  const [markAsRead] = useMarkAsReadMutation();
  const history = useHistory();
  const { survey, candidate, job } = useSurveyNotificationData(notification);
  const detailsData = [
    { label: 'Survey name', value: survey.name },
    { label: 'Job name', value: job.name },
    { label: 'Candidate name', value: candidate.name },
    { label: 'Sent by', value: survey.sentBy?.name },
    { label: 'Sent at', value: survey.sentAt },
  ].filter((item) => item.value);

  const handleFillSurvey = () => {
    if (survey.id) {
      markAsRead({ id: notification?.id });
      history.push(`/tasks/jobs/survey/${survey.id}`);
      onClose();
    }
  };

  return (
    <Flex alignItems="baseline" gap="6px">
      <Center minW="34px" h="34px" borderRadius="sm" bg="primary-100">
        <Icon as={LayersThree02} color="primary-500" width="16px" />
      </Center>
      <Flex flexDir="column" ml="16px" gap="8px" alignSelf="start" flex="1">
        <Text>
          <Text as="span" fontSize="sm">
            New survey to fill out on{' '}
          </Text>
          {candidate.name && (
            <Text as="span" size="sm-semi-bold">
              <NotificationLink
                to={candidate.url || `/candidates/${candidate.id}`}
                label={candidate.name}
                onClose={onClose}
                notification={notification}
              />
            </Text>
          )}
          {job.name && (
            <>
              <Text as="span" fontSize="sm">
                {' '}
                for{' '}
              </Text>
              <Text as="span" size="sm-semi-bold">
                <NotificationLink
                  to={job.url || '#'}
                  label={job.name}
                  onClose={onClose}
                  notification={notification}
                />
              </Text>
            </>
          )}
        </Text>

        <RequisitionDetailsSection title="Details">
          <RequisitionDetailsList data={detailsData} />
        </RequisitionDetailsSection>

        <NotificationTime notification={notification} />
        <Button
          w="fit-content"
          variant="ats-primary"
          borderRadius="8px"
          onClick={handleFillSurvey}
          maxH="34px"
          data-test-id="fill-survey-button"
        >
          Fill out survey
        </Button>
      </Flex>
    </Flex>
  );
};

export const SurveyRequestNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <SurveyRequest notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
